import React, { useEffect, useState } from "react";
import axios from "axios";

export default function PaymentSetup() {
  const [editMode, setEditMode] = useState(false);
  const [loading, setLoading] = useState(true);

  const [payments, setPayments] = useState({
    bkash: { enabled: false, number: "", instruction: "" },
    nagad: { enabled: false, number: "", instruction: "" },
    rocket: { enabled: false, number: "", instruction: "" },
  });

  // ================= LOAD FROM API =================
  useEffect(() => {
  const fetchPayments = async () => {
    try {
      const res = await axios.get(
        "https://api.earnmoney0.top/api/payment-methods"
      );
      console.log("PAYMENT METHODS 👉", res.data);

      const map = { bkash: {}, nagad: {}, rocket: {} };

      res.data.forEach((m) => {
        const obj = {
          enabled: m.status === "active",
          number: m.number,
          instruction: m.instruction,
        };
        if (m.name === "বিকাশ") map.bkash = obj;
        if (m.name === "নগদ") map.nagad = obj;
        if (m.name === "রকেট") map.rocket = obj;
      });

      setPayments(map);
    } catch (err) {
      console.error("Fetch error:", err);
    } finally {
      setLoading(false);
    }
  };

  fetchPayments();
}, []);

  // ================= SAVE TO API =================
  const handleSave = async () => {
  try {
    const payload = Object.keys(payments).map((key) => ({
      name:
        key === "bkash" ? "বিকাশ" : key === "nagad" ? "নগদ" : "রকেট",
      number: payments[key].number,
      instruction: payments[key].instruction,
      status: payments[key].enabled ? "active" : "inactive",
    }));

    await axios.post(
      "https://api.earnmoney0.top/api/payment-methods",
      payload
    );

    alert("✅ Payment settings saved");
    setEditMode(false);
  } catch (err) {
    console.error(err);
    alert("❌ Save failed");
  }
};

  const toggleEnable = (key) => {
    if (!editMode) return;
    setPayments({
      ...payments,
      [key]: {
        ...payments[key],
        enabled: !payments[key].enabled,
      },
    });
  };

  const handleChange = (key, field, value) => {
    setPayments({
      ...payments,
      [key]: {
        ...payments[key],
        [field]: value,
      },
    });
  };

  if (loading) {
  return (
    <div style={{
      minHeight: "100vh",
      background: "#0b0f1a",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: "#fff",
      fontSize: 18
    }}>
      Loading payment setup...
    </div>
  );
}

  return (
    <div style={styles.page}>
      {/* HEADER */}
      <div style={styles.header}>
        <h1 style={styles.title}>💳 Payment Setup</h1>

        <button
          onClick={() => (editMode ? handleSave() : setEditMode(true))}
          style={styles.editBtn}
        >
          {editMode ? "💾 Save" : "✏️ Edit"}
        </button>
      </div>

      {Object.keys(payments).map((key) => (
        <div key={key} style={styles.card}>
          <div style={styles.cardHeader}>
            <h2 style={styles.methodTitle}>{key.toUpperCase()}</h2>

            <div
              onClick={() => toggleEnable(key)}
              style={{
                ...styles.switch,
                backgroundColor: payments[key].enabled
                  ? "#22c55e"
                  : "#ef4444",
                justifyContent: payments[key].enabled
                  ? "flex-end"
                  : "flex-start",
                opacity: editMode ? 1 : 0.5,
              }}
            >
              <div style={styles.knob}></div>
            </div>
          </div>

          <div style={styles.field}>
            <label style={styles.label}>Payment Number</label>
            <input
              disabled={!editMode}
              value={payments[key].number}
              onChange={(e) =>
                handleChange(key, "number", e.target.value)
              }
              style={styles.input}
            />
          </div>

          <div style={styles.field}>
            <label style={styles.label}>Instruction</label>
            <textarea
              disabled={!editMode}
              value={payments[key].instruction}
              onChange={(e) =>
                handleChange(key, "instruction", e.target.value)
              }
              style={styles.textarea}
            />
          </div>
        </div>
      ))}
    </div>
  );
}

/* ===================== CSS ===================== */

const styles = {
  page: {
    minHeight: "100vh",
    backgroundColor: "#0b0f1a",
    color: "#ffffff",
    padding: "20px",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "20px",
  },
  title: { fontSize: "26px", fontWeight: 700 },
  editBtn: {
    background: "#38bdf8",
    border: "none",
    padding: "10px 20px",
    borderRadius: "8px",
    cursor: "pointer",
    fontWeight: 700,
  },
  card: {
    background: "#020617",
    borderRadius: "14px",
    padding: "18px",
    marginBottom: "20px",
    border: "1px solid #1e293b",
  },
  cardHeader: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "14px",
  },
  methodTitle: { fontSize: "20px", color: "#facc15" },
  field: { marginBottom: "14px" },
  label: { marginBottom: "6px", display: "block" },
  input: {
    width: "100%",
    padding: "10px",
    background: "#111827",
    border: "1px solid #374151",
    color: "#fff",
    borderRadius: "8px",
  },
  textarea: {
    width: "100%",
    minHeight: "90px",
    background: "#111827",
    border: "1px solid #374151",
    color: "#fff",
    borderRadius: "8px",
    padding: "10px",
  },
  switch: {
    width: "58px",
    height: "30px",
    borderRadius: "50px",
    display: "flex",
    alignItems: "center",
    padding: "4px",
    cursor: "pointer",
  },
  knob: {
    width: "22px",
    height: "22px",
    backgroundColor: "#fff",
    borderRadius: "50%",
  },
};